module.exports = __webpack_public_path__ + "static/email-template-receipt-doggify-cb8938c3d2284367517c3f132ccf09b0.png";